<template>
  <div v-if="show" class="tabbar-container">
    <div class="tabbar-bg-box">
      <div class="tabbar-bg-frost" :style="tabbarBgMaskStyle"></div>
      <img
        class="tabbar-bg-img tabbar-bg-img--light"
        :src="getImageUrlWithCDN_LOCAL('/tabbar/index_53000/bg-light.svg')"
        alt=""
        aria-hidden="true"
      />
      <img
        class="tabbar-bg-img tabbar-bg-img--dark"
        :src="getImageUrlWithCDN_LOCAL('/tabbar/index_53000/bg-dark.svg')"
        alt=""
        aria-hidden="true"
      />
    </div>

    <van-tabbar v-model="active" route placeholder :safe-area-inset-bottom="false" @change="onChange">
      <!-- replace to="/" -->
      <van-tabbar-item>
        <template #icon>
          <div :class="['tabbar-item-content', { __on: active == 0 }]">
            <div v-show="active == 0" class="icon-active-wrap">
              <span class="tabbar-icon-glow" aria-hidden="true"></span>
              <div class="icon-active-layers">
                <span
                  class="icon-layer icon-layer--theme"
                  :style="getTabOnThemeMaskStyle('home')"
                  aria-hidden="true"
                ></span>
                <img
                  class="icon __on icon-layer--shadow"
                  :src="getImageUrlWithCDN_LOCAL('/tabbar/index_53000/home_on_shadow.png')"
                />
              </div>
            </div>
            <img
              v-show="active != 0"
              class="icon"
              :src="getImageUrlWithCDN_LOCAL('/tabbar/index_53000/home_off.png')"
            />
            <span class="name">Início</span>
          </div>
        </template>
      </van-tabbar-item>

      <van-tabbar-item>
        <template #icon>
          <div :class="['tabbar-item-content', { __on: active == 1 }]">
            <div v-show="active == 1" class="icon-active-wrap">
              <span class="tabbar-icon-glow" aria-hidden="true"></span>
              <div class="icon-active-layers">
                <span
                  class="icon-layer icon-layer--theme"
                  :style="getTabOnThemeMaskStyle('top-up')"
                  aria-hidden="true"
                ></span>
                <img
                  class="icon __on icon-layer--shadow"
                  :src="getImageUrlWithCDN_LOCAL('/tabbar/index_53000/top-up_on_shadow.png')"
                />
              </div>
            </div>
            <img
              v-show="active != 1"
              class="icon"
              :src="getImageUrlWithCDN_LOCAL('/tabbar/index_53000/top-up_off.png')"
            />
            <span class="name">Depósito</span>
          </div>
        </template>
      </van-tabbar-item>

      <van-tabbar-item>
        <template #icon>
          <div :class="['tabbar-item-content __plus', { __on: active == 2 }]">
            <div class="large-button-wrap">
              <span class="large-button-circle" aria-hidden="true"></span>
              <img class="icon __plus" :src="getImageUrlWithCDN_LOCAL('/tabbar/index_53000/acting.png')" />
            </div>
            <span class="name">Agente</span>
          </div>
        </template>
      </van-tabbar-item>

      <van-tabbar-item>
        <template #icon>
          <div :class="['tabbar-item-content', { __on: active == 3 }]">
            <div v-show="active == 3" class="icon-active-wrap">
              <span class="tabbar-icon-glow" aria-hidden="true"></span>
              <div class="icon-active-layers">
                <span
                  class="icon-layer icon-layer--theme"
                  :style="getTabOnThemeMaskStyle('activity')"
                  aria-hidden="true"
                ></span>
                <img
                  class="icon __on icon-layer--shadow"
                  :src="getImageUrlWithCDN_LOCAL('/tabbar/index_53000/activity_on_shadow.png')"
                />
              </div>
            </div>
            <img
              v-show="active != 3"
              class="icon"
              :src="getImageUrlWithCDN_LOCAL('/tabbar/index_53000/activity_off.png')"
            />
            <span class="name">Promoções</span>
          </div>
        </template>
      </van-tabbar-item>

      <!-- replace to="/Personal" -->
      <van-tabbar-item>
        <template #icon>
          <div :class="['tabbar-item-content', { __on: active == 4 }]">
            <div v-show="active == 4" class="icon-active-wrap">
              <span class="tabbar-icon-glow" aria-hidden="true"></span>
              <div class="icon-active-layers">
                <span
                  class="icon-layer icon-layer--theme"
                  :style="getTabOnThemeMaskStyle('user')"
                  aria-hidden="true"
                ></span>
                <img
                  class="icon __on icon-layer--shadow"
                  :src="getImageUrlWithCDN_LOCAL('/tabbar/index_53000/user_on_shadow.png')"
                />
              </div>
            </div>
            <img
              v-show="active != 4"
              class="icon"
              :src="getImageUrlWithCDN_LOCAL('/tabbar/index_53000/user_off.png')"
            />
            <span class="name">Perfil</span>
          </div>
        </template>
      </van-tabbar-item>
    </van-tabbar>

    <LoginRegisterPopup ref="LoginRegisterRef" />
  </div>
</template>

<script setup>
import { getTabOnThemeMaskStyle as getTabOnThemeMaskStyleBase, useTabBarTemplate } from './js/index.js'

const getTabOnThemeMaskStyle = (tab) => getTabOnThemeMaskStyleBase(tab, 'index_53000')

const tabbarBgMaskStyle = (() => {
  const mask = `url("${getImageUrlWithCDN_LOCAL('/tabbar/index_53000/bg-shape-mask.svg')}")`
  return {
    WebkitMaskImage: mask,
    maskImage: mask,
  }
})()

const {
  active,
  LoginRegisterRef,
  onChange,
  show,
} = useTabBarTemplate()
</script>

<style lang="less" scoped>
@import url('./css/index.less');

.tabbar-container {
  height: 78px;

  :deep(.van-tabbar) {
    height: 60px;
  }

  .tabbar-bg-box {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 78px;
    pointer-events: none;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;

    .tabbar-bg-frost {
      position: absolute;
      inset: 0;
      z-index: 0;
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      mask-size: 100% 100%;
      mask-repeat: no-repeat;
      mask-position: center bottom;
      -webkit-mask-size: 100% 100%;
      -webkit-mask-repeat: no-repeat;
      -webkit-mask-position: center bottom;
    }

    .tabbar-bg-img {
      position: absolute;
      inset: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      object-fit: fill;

      &--light {
        display: var(--tabbar-bg-img-display-light, block);
      }

      &--dark {
        display: var(--tabbar-bg-img-display-dark, none);
      }
    }
  }

  .tabbar-item-content {
    @icon_size: 30px;
    @icon_slot_size: 36px;
    height: 78px;

    &:not(.__plus) {
      > .icon {
        height: @icon_size;
        margin: ((@icon_slot_size - @icon_size) / 2) 0;
      }
    }

    .icon-active-wrap {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: @icon_slot_size;
      height: @icon_slot_size;
      flex-shrink: 0;
    }

    .tabbar-icon-glow {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 32px;
      height: 32px;
      transform: translate(-50%, -48%);
      border-radius: 50%;
      background: var(--tabbar-icon-glow-color);
      filter: blur(var(--tabbar-icon-glow-blur));
      pointer-events: none;
      z-index: 0;
    }

    .icon-active-layers {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
    }

    .icon-layer--theme {
      position: absolute;
      top: 50%;
      left: 50%;
      width: @icon_size;
      height: @icon_size;
      transform: translate(-50%, -50%);
      background: var(--tabbar-icon-active-bg);
      -webkit-mask-repeat: no-repeat;
      mask-repeat: no-repeat;
      -webkit-mask-position: center;
      mask-position: center;
      -webkit-mask-size: contain;
      mask-size: contain;
      filter: var(--tabbar-icon-theme-filter);
      pointer-events: none;
    }

    .icon-active-wrap .icon.__on,
    .icon-layer--shadow {
      position: relative;
      z-index: 1;
    }

    .icon-layer--shadow {
      filter: var(--color-value-icon-filter);
    }

    &.__on {
      .icon.__on {
        border-radius: 50%;
      }
    }

    .name {
      margin-top: 2px;
      flex-shrink: 0;
      line-height: 1;
    }

    &.__plus {
      position: relative;
      height: 60px;
      justify-content: flex-end;
      padding-bottom: 6px;

      .large-button-wrap {
        position: relative;
        width: 49px;
        height: 49px;
        margin-top: -18px;
      }

      .large-button-circle {
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background: var(--button-primary-bg);
        z-index: 0;
      }

      .icon.__plus {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 1;
        width: 35px;
        height: 33px;
        margin: 0;
        transform: translate(-50%, -50%);
      }

      .name {
        position: relative;
        z-index: 1;
        margin-top: 2px;
      }
    }
  }
}
</style>
